const state = {
  version: "",
  isLatestVersion: true,
  profile: 0,

  keyMatrix: {
    "0x00": ["0x01", "0x00", "0xf0", "0x00"],
    "0x02": ["0x01", "0x00", "0xf2", "0x00"],
    "0x01": ["0x01", "0x00", "0xf1", "0x00"],
    "0x0e": ["0x01", "0x00", "0xf5", "0x01"],
    "0x0f": ["0x01", "0x00", "0xf5", "0xff"],
    "0x03": ["0x01", "0x00", "0xf4", "0x00"],
    "0x04": ["0x01", "0x00", "0xf3", "0x00"],
  },
  macroData: [],
  DPI: {
    currentID: 0, // 0~5
    DPItime: [800, 1600, 2400, 3200, 5000, 10000, 20000, 26000], // （50~26000）
    isOpen: 1, //1:开启x-y同步，0：关闭x-y同步
    xDPI: [800, 1600, 2400, 3200, 5000, 10000, 20000, 26000], // （50~26000）
    yDPI: [800, 1600, 2400, 3200, 5000, 10000, 20000, 26000], // （50~26000）
    DPIcolor: [
      "#FF0000",
      "#00FF00",
      "#0000FF",
      "#00FFFF",
      "#800080",
      "#FFFF00",
      "#FF00FF",
      "#ffffff",
    ], // 000000~ffffff
    DPImax: 8, // DPI数量，范围：1-8
    setDPIButton: 1, // DPI快速切换开关：1:开启，0：关闭
  },
  param: {
    profile: 0, // 当前配置层 0~7
    profileMax: 2, // 最大配置数量 1~8，默认 2
    AM30ProfileKeySwitch: null, // 组合键切换开关：1 开，0 关，null=尚未收到独立上报
    keySensitivity: 1, //按键灵敏度 1~10
    USBDebounce: 3, // USB 去抖动 1~255
    twoPointFourGDebounce: 1, // 2.4G 去抖动 1~255
    BTDebounce: 1, // 蓝牙去抖动 1~255
    buttonChangeTime: 12, // 双击间隔时间 1~255
    wheelToButton: 1, // 滚轮模拟按键消抖 1~255
    buttonToWheel: 1, // 按键模拟滚轮消抖 1~255
    sleepOneTime24G: 30, // 2.4G一次休眠 0~65535
    sleepOneTimeBT: 600, // 蓝牙一次休眠 0~65535
    reportRate: 1000, // 鼠标回报率 125,250,500,1000,2000,4000,8000
    liftCutOff: 1, // 静默高度 低：0，高：1
    motionSync: 1, // 运动同步开关：开：1， 关：0
    angleSnap: 0, // 直线修正 关：0， 开：1
    rippleCorrection: 0, // 波纹修正 关：0， 开：4
    fpsMode: 0, // 猛攻模式开关：开：1， 关：0
    setSNEDORAngle: null, // 鼠标倾角：[-90, 90]，null 表示设备不支持
    charLight: [255, 255, 255], // 充电中灯效
    charEndLight: [255, 0, 255], // 满电灯效
    charLightswitch: 1, // 充电灯开关：0:关，1：开
    mouseID: 19351, // 1935 的DPI上限26000，其它的DPI上限30000
  },
  light: {
    charSwitch: 1, // 充电灯开关：0:关，1：开
    effect: 0, // 范围：0-8 含义：关闭/常亮/呼吸/霓虹/光波/跑马/圆环/缓冲/追捕
    speed: 0, // 范围：0-4 含义：灯光速度
    bright: 0, // 范围：0-4 含义：灯光亮度
    option: 0, // 范围：0-8 含义：对应红、橙、黄、绿、青、蓝、紫、自定义、炫彩模式
    color: [255, 255, 255], // 范围：0-255 含义：RGB颜色
  },
};

const actions = {
  setVersion({ commit }, { version, isLatestVersion }) {
    commit("SET_VERSION", { version, isLatestVersion });
  },
  setProfile({ commit }, profile) {
    commit("SET_PROFILE", profile);
  },
  setKeyMatrix({ commit }, keyMatrix) {
    for (const key in keyMatrix) {
      let item = keyMatrix[key];
      if (item[0] == "0x00" && item[2] != "0x00" && item[3] == "0x00") {
        item[3] = item[2];
        item[2] = "0x00";
      }
    }
    commit("SET_KEY_MATRIX", keyMatrix);
  },
  setMacroData({ commit }, macroData) {
    macroData.map((i) => {
      i.macro_name = i.macro_name || "M_" + i.index;
      // i.key_code = "";
      // i.change_key = "";
    });
    commit("SET_MACRO_DATA", macroData);
  },
  setDPI({ commit }, DPI) {
    commit("SET_DPI", DPI);
  },
  setParam({ commit }, param) {
    commit("SET_PARAM", param);
  },
  setLight({ commit }, light) {
    commit("SET_LIGHT", light);
  },
};

const mutations = {
  SET_VERSION: (state, { version, isLatestVersion }) => {
    state.version = version;
    state.isLatestVersion = isLatestVersion;
  },
  SET_PROFILE: (state, profile) => {
    state.profile = profile;
  },
  SET_KEY_MATRIX: (state, keyMatrix) => {
    state.keyMatrix = keyMatrix;
  },
  SET_MACRO_DATA: (state, macroData) => {
    state.macroData = macroData;
  },
  SET_DPI: (state, DPI) => {
    state.DPI = DPI;
  },
  SET_PARAM: (state, param) => {
    state.param = {
      ...state.param,
      ...param,
    };
  },
  SET_LIGHT: (state, light) => {
    state.light = light;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
